// extracted by mini-css-extract-plugin
export default {"modal":"Modal2_modal__HwCdk","modalContent":"Modal2_modalContent__07hrj","close":"Modal2_close__MBJSS","image":"Modal2_image__7FKZQ"};